/**
 * Payment Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PaymentCreateRequestDTO { 
    orderCode: string;
    amount: number;
    currency: string;
    payType: PaymentCreateRequestDTO.PayTypeEnum;
    platform?: PaymentCreateRequestDTO.PlatformEnum;
    client: PaymentCreateRequestDTO.ClientEnum;
    description?: string;
    tenantId?: number;
    retryAttempt?: number;
}
export namespace PaymentCreateRequestDTO {
    export const PayTypeEnum = {
        Cash: 'CASH',
        BankTransfer: 'BANK_TRANSFER',
        Card: 'CARD',
        EWallet: 'E_WALLET',
        Cod: 'COD'
    } as const;
    export type PayTypeEnum = typeof PayTypeEnum[keyof typeof PayTypeEnum];
    export const PlatformEnum = {
        Momo: 'MOMO',
        Zalopay: 'ZALOPAY',
        Vnpay: 'VNPAY',
        Stripe: 'STRIPE',
        Cod: 'COD',
        None: 'NONE'
    } as const;
    export type PlatformEnum = typeof PlatformEnum[keyof typeof PlatformEnum];
    export const ClientEnum = {
        Pos: 'POS',
        BackOffice: 'BACK_OFFICE'
    } as const;
    export type ClientEnum = typeof ClientEnum[keyof typeof ClientEnum];
}


